module.exports = __webpack_public_path__ + "img/loan_check_list.62453b05.png";